import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-submitted-approval',
  templateUrl: './submitted-approval.component.html',
  styleUrls: ['./submitted-approval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubmittedApprovalComponent {
  @Input()
  pageHeader = 'submittedPageHeader';

  @Input()
  pageDescription = 'submittedPageDescription';

  @Input()
  svgIconPath = 'submitted';

  buildTranslationKey(relativeKey: string): string {
    return `externalApproval.${relativeKey}`;
  }
}
